import React, {useEffect} from "react";

export const useClickAwayListener = (ref: React.RefObject<HTMLElement>, onClickAway: () => void) => {
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (event.button === 0 && ref.current && !ref.current.contains(event.target as Node)) {
				onClickAway()
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [onClickAway, ref]);
}